<script setup>
import {ref, reactive, onMounted, inject, onBeforeUnmount, watch, nextTick, useTemplateRef, onUpdated} from 'vue';
import {onBeforeRouteLeave, useRoute} from 'vue-router';
    import { useStore } from 'vuex';
    import axios from "axios";

    const notify = inject('notify');

    import { useCommonComposable } from '@/composables/commonComposable.js';

    import ProgressBar from "@/components/App/progress-bar.vue";
import YaDeliveryWidget from "@/components/App/ya-delivery-widget.vue";

    const { user, getUser, isMobile } = useCommonComposable();

    const store = useStore();

    const emit = defineEmits(['fill']);

    const emailValue = ref('')
    const passwordValue = ref('')
    const phoneValue = ref('')
    const errorText = ref('')
    const errorType = ref('')
    const firstnameValue = ref('')
    const lastnameValue = ref('')
    const codeValue = ref('')
    const code = ref(0);

    const route = useRoute();

    let countryValue = ref('');
    let deliveryServiceValue = ref('Яндекс ПВЗ');
    let zipCodeValue = ref('');
    let regionValue = ref('');
    let cityValue = ref('');
    let streetValue = ref('');
    let houseNumberValue = ref('');
    let apartmentValue = ref('—');
    let addressActiveStatus = ref('');
    let yaId = ref('');

    const registerStage = ref(1)

    const props = defineProps({
        user: Array
    });

    const checkPageHeight = () => {
        if (isMobile.value) { return }

        const app = document.querySelector('#app');

        if (route.name === 'not-found') {
            app.style.minHeight = `${document.documentElement.clientHeight}px`;
        } else {
            app.style.minHeight = `${document.documentElement.clientHeight-269}px`;
        }
        // 269px is header + ticker + footer height
    };


    const hasNumbers = (str) => {
        return /\d/.test(str);
    }

    const hasSpecialChars = (str) => {
        const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return specialChars.test(str);
    }

    const validateEmail = (email) => {
        if (!email.split('@')[1]) {
            errorText.value = 'Указан невалидный email. Не забудьте указать полный адрес и использовать символ @';
            errorType.value = 'no-email'
            return false
        }

        return true
    }

    const validatePhone = (phone) => {
        if (!(/^(?:\+)\d+$/.test(phone))) {
            errorText.value = 'Невалидный номер телефона. Начните с символа + и далее указывайте только числа';
            errorType.value = 'no-phone'
            return false
        }

        if (phone.split('').length < 12) {
            errorText.value = 'Недостаточное количество символов в номере телефона';
            errorType.value = 'valid-error'
            return false
        }

        return true
    }

    const validatePassword = (password) => {
        if (password.split('').length < 8) {
            errorText.value = 'Минимальное количество символов пароля: 8';
            errorType.value = 'valid-error'
            return false
        }

        return true
    }

    const validateName = (firstname, lastname) => {
        if (firstname.split('').length < 2) {
            errorText.value = 'Минимальное количество символов для поля имени: 2'
            errorType.value = 'no-firstname'
            return false
        }

        if (lastname.split('').length < 2) {
            errorText.value = 'Минимальное количество символов для поля фамилии: 2'
            errorType.value = 'no-lastname'
            return false
        }

        if (hasNumbers(firstname) || hasNumbers(lastname)) {
            errorText.value = 'В поле имени и фамилии содержатся числа'
            errorType.value = 'valid-error'
            return false
        }

        if (hasSpecialChars(firstname) || hasSpecialChars(lastname)) {
            errorText.value = 'В поле имени и фамилии содержатся спец. символы'
            errorType.value = 'valid-error'
            return false
        }

        return true
    }

    const sendConfirmCode = async () => {
        if (!validateName(firstnameValue.value, lastnameValue.value)) return;
        if (!validateEmail(emailValue.value) || !validatePassword(passwordValue.value) || !validatePhone(phoneValue.value)) return;
        errorText.value = '';
        errorType.value = '';

        code.value = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000

        const html =
            `<html>
<head>
    <style>
        table {
            border-collapse: separate;
            table-layout: fixed;
        }
        table td {
            border-collapse: collapse
        }
        .ExternalClass {
            width: 100%
        }
        .ExternalClass,
        .ExternalClass p,
        .ExternalClass span,
        .ExternalClass font,
        .ExternalClass td,
        .ExternalClass div {
            line-height: 100%
        }
        body, a, li, p, h1, h2, h3 {
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
        }
        html {
            -webkit-text-size-adjust: none !important
        }
        body {
            min-width: 100%;
            margin: 0;
            padding: 0;
        }
        body, #innerTable {
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale
        }
        #innerTable img+div {
            display: none !important
        }
        img {
            Margin: 0;
            padding: 0;
            -ms-interpolation-mode: bicubic
        }
        h1, h2, h3, p, a {
            line-height: inherit;
            overflow-wrap: normal;
            white-space: normal;
            word-break: break-word
        }
        a {
            text-decoration: none
        }
        h1, h2, h3, p {
            min-width: 100%!important;
            width: 100%!important;
            max-width: 100%!important;
            display: inline-block!important;
            border: 0;
            padding: 0;
            margin: 0
        }
        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important
        }
        u + #body a {
            color: inherit;
            text-decoration: none;
            font-size: inherit;
            font-family: inherit;
            font-weight: inherit;
            line-height: inherit;
        }
        a[href^="mailto"],
        a[href^="tel"],
        a[href^="sms"] {
            color: inherit;
            text-decoration: none
        }

        @media (min-width: 481px) {
            .hd { display: none!important }
        }

        @media (max-width: 480px) {
            .hm { display: none!important }
        }

        @media (max-width: 480px) {
            .t37,.t42{line-height:0!important;display:none!important}.t38{padding:40px!important;border-radius:0!important}.t28{text-align:left!important}.t27{vertical-align:top!important;width:auto!important;max-width:100%!important}
        }
    </style>
</head>
<body id="body" class="t45" style="min-width:100%;margin:0;padding:0;background-color:#FFFFFF;">
<div class="t44" style="background-color:#FFFFFF;"><table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" align="center"><tr><td class="t43" style="font-size:0;line-height:0;background-color:#FFFFFF;" valign="top" align="center">
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" align="center" id="innerTable"><tr><td><div class="t37" style="line-height:50px;font-size:1px;display:block;"></div></td></tr><tr><td align="center">
        <table class="t41" role="presentation" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;"><tr><td width="600" class="t40" style="width:600px;">
            <table class="t39" role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;"><tr><td class="t38" style="border:1px solid #EBEBEB;overflow:hidden;background-color:#FFFFFF;padding:44px 42px 32px 42px;border-radius:3px 3px 3px 3px;"><table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="width:100% !important;"><tr><td align="left">
                <table class="t4" role="presentation" cellpadding="0" cellspacing="0" style="Margin-right:auto;margin-bottom: 20px"><tr><td width="42" class="t3" style="width:42px;">
                    <table class="t2" role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;"><tr><td class="t1"><div style="font-size:0;"><img class="t0" style="display:block;border:0;height:auto;width:100%;Margin:0;max-width:100%;" width="42" height="42" alt="" src="https://dd4d2dd5-22a6-45c7-a084-273ca1ab208a.b-cdn.net/e/a0ebf28d-eee4-412c-af6a-4012d694d1ce/9edd498a-0a29-415f-8703-8234e1a0cbb3.png"/></div></td></tr></table>
                </td></tr></table>
            </td></tr><tr><td><div class="t5" style="line-height:42px;font-size:1px;display:block;"></div></td></tr><tr><td align="center">
                <table class="t10" role="presentation" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;"><tr><td width="514" class="t9" style="width:600px;">
                    <table class="t8" role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;"><tr><td class="t7" style="border-bottom:1px solid #EFF1F4;padding:0 0 18px 0;"><h1 class="t6" style="margin:0;font-family:Helvetica,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:28px;font-weight:700;font-style:normal;font-size:22px;text-decoration:none;text-transform:none;letter-spacing:-1px;direction:ltr;color:#141414;text-align:left;">Ваш код подтверждения</h1></td></tr></table>
                </td></tr></table>
            </td></tr><tr><td><div class="t11" style="line-height:18px;font-size:1px;display:block;">&nbsp;&nbsp;</div></td></tr><tr><td align="center">
                <table class="t16" role="presentation" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;"><tr><td width="514" class="t15" style="width:600px;">
                    <table class="t14" role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;"><tr><td class="t13"><p class="t12" style="margin:0;font-family:Helvetica,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:25px;font-weight:400;font-style:normal;font-size:15px;text-decoration:none;text-transform:none;letter-spacing:-0.1px;direction:ltr;color:#141414;text-align:left;">Вы указали этот адрес для регистрации на сайте оригинальных джерси: <a href="https://ballershop.ru" style="text-decoration: underline; color: #1c1c1c">ballershop.ru</a>. Для подтверждения укажите этот код на сайте:</p></td></tr></table>
                </td></tr></table>
            </td></tr><tr><td><div class="t17" style="line-height:15px;font-size:1px;display:block;">&nbsp;&nbsp;</div></td></tr><tr><td align="center">
                <table class="t22" role="presentation" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;"><tr><td width="514" class="t21" style="width:600px;">
                    <table class="t20" role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;"><tr><td class="t19" style="padding:0 0 1px 0;"><h1 class="t18" style="margin:0;font-family:Montserrat,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:28px;font-weight:700;font-style:normal;font-size:26px;text-decoration:none;text-transform:none;letter-spacing:-1px;direction:ltr;color:#DC33DF;text-align:left;">${code.value}</h1></td></tr></table>
                </td></tr></table>
            </td></tr><tr><td><div class="t23" style="line-height:1px;font-size:1px;display:block;">&nbsp;&nbsp;</div></td></tr><tr><td><div class="t32" style="mso-line-height-rule:exactly;mso-line-height-alt:40px;line-height:40px;font-size:1px;display:block;">&nbsp;&nbsp;</div></td></tr><tr><td align="center">
                <table class="t36" role="presentation" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;"><tr><td width="514" class="t35" style="width:600px;">
                    <table class="t34" role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;"><tr><td class="t33" style="border-top:1px solid #DFE1E4;padding:24px 0 0 0;"><div class="t31" style="width:100%;text-align:left;"><div class="t30" style="display:inline-block;"><table class="t29" role="presentation" cellpadding="0" cellspacing="0" align="left" valign="top">
                        <tr class="t28"><td></td><td class="t27" valign="top">
                            <table role="presentation" width="100%" cellpadding="0" cellspacing="0" class="t26" style="width:auto;"><tr><td class="t25" style="background-color:#FFFFFF;text-align:center;line-height:20px;"><span class="t24" style="display:block;margin:0;font-family:Helvetica,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:20px;font-weight:500;font-style:normal;font-size:12px;text-decoration:none;direction:ltr;color:#B4BECC;text-align:center;"><a href="https://ballershop.ru" style="color: #B4BECC !important">https://ballershop.ru</a></span></td></tr></table>
                        </td>
                            <td></td></tr>
                    </table></div></div></td></tr></table>
                </td></tr></table>
            </td></tr></table></td></tr></table>
        </td></tr></table>
    </td></tr><tr><td><div class="t42" style="line-height:50px;font-size:1px;display:block;">&nbsp;&nbsp;</div></td></tr></table></td></tr></table></div><div class="gmail-fix" style="display: none; white-space: nowrap; font: 15px courier; line-height: 0;"></div>
</body>
</html>`

        const response = await axios.post(process.env.VUE_APP_API_URL + "/mail/sendMsg", {
            to: emailValue.value,
            subject: 'Регистрация на сайте — Baller',
            html: html
        })

        if (response.status === 200) {
            registerStage.value = 2
        } else {
            notify('Ошибка: не смогли отправить Email')
        }
    }

    const registerUser = async () => {
        if (parseInt(codeValue.value) !== code.value) {
            notify('Ошибка: указан неверный код')
            return
        }

        const body = {
            firstname: firstnameValue.value,
            lastname: lastnameValue.value,
            email: emailValue.value,
            roleName: 'Пользователь',
            password: passwordValue.value,
            phone: phoneValue.value,
        }

        try {
            const response = await axios.post(process.env.VUE_APP_API_URL + "/users/addUser", body)

            if (response?.data.type === 'successful') {
                await initLogin()
                registerStage.value = 3
            } else if (response?.data.type === 'error') {
                notify('Ошибка: ' + response.data.message)
                registerStage.value = 1
            }
        } catch (error) {}
    }

    const initLogin = async () => {
        if (!emailValue.value || !passwordValue.value) {
            errorText.value = 'Не указан email или пароль';
            errorType.value = 'valid-error';
            return;
        }

        if (!validateEmail(emailValue.value) || !validatePassword(passwordValue.value)) return;

        errorText.value = '';
        errorType.value = '';

        const config = { headers: { 'Cache-Control': 'no-cache' } };
        const response = await axios.post(process.env.VUE_APP_API_URL + "/users/login", {
            email: emailValue.value,
            password: passwordValue.value,
        }, config); // делаем запрос к API

        if (response?.data.token) {
            saveToken(response.data.token);
            await getUser()
            await store.dispatch('address/fetchUserAddresses', { customerId: user.value[0].ID }); // Загружаем адреса текущего пользователя
        }

        if (response?.data?.error) {
            notify(response.data?.error);
            errorText.value = response.data.error
            errorType.value = response.data.type
        }
    }

    const saveToken = (token) => {
        setCookie('authToken', token, 7)
    }

    const setCookie = (cname, cvalue, exdays) => {
        const d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        const expires = "expires=" + d.toUTCString()
        document.cookie = `${cname}=${cvalue};${expires};path=/`
        document.cookie = `${cname}=${encodeURIComponent(cvalue)};${expires};HttpOnly;Path=/;SameSite=Lax`
    }

    const validNewAddressValues = () => {
        return !(deliveryServiceValue.value === ''
            || cityValue.value === ''
            || streetValue.value === ''
            || houseNumberValue.value === ''
            || apartmentValue.value === ''
            || regionValue.value === ''
            || countryValue.value === ''
            || zipCodeValue.value === '');
    }

    const addAddress = async () => {
        if (!validNewAddressValues()) {
            notify('Ошибка: пожалуйста, заполните все поля')
            return
        }
        const config = { headers: { 'Cache-Control': 'no-cache' } };
        const data = {
            deliveryAddressId: 0,
            customerId: user.value[0]['ID'],
            addressName: 'Адрес 1',
            deliveryService: 'Яндекс ПВЗ',
            deliveryIndex: zipCodeValue.value,
            country: countryValue.value,
            region: regionValue.value,
            city: cityValue.value,
            street: streetValue.value,
            house: houseNumberValue.value,
            apartment: apartmentValue.value,
            addressStatus: addressActiveStatus.value,
            yaId: yaId.value,
        }

        const response = await axios.post(process.env.VUE_APP_API_URL + "/addresses/addAddress", data, config);
        if (response.status === 200) {
            store.commit('RESET_MODULE', { moduleName: 'address' });
            notify('Новый адрес добавлен успешно')
            emit('fill')
        }
        resetValues()
    }

    const resetValues = () => {
        deliveryServiceValue.value = 'Яндекс ПВЗ'
        zipCodeValue.value = ''
        countryValue.value = ''
        regionValue.value = ''
        cityValue.value = ''
        streetValue.value = ''
        houseNumberValue.value = ''
        apartmentValue.value = ''
    }

    const updateYaAddress = async (data) => {
        zipCodeValue.value = data.address.postal_code
        countryValue.value = data.address.country
        cityValue.value = data.address.locality
        regionValue.value = data.address.region
        streetValue.value = data.address.street || '—'
        houseNumberValue.value = data.address.house
        apartmentValue.value = '—'
        deliveryServiceValue.value = 'Яндекс ПВЗ'
        yaId.value = data.id
    }

    const stages = ref([
        {
            header: 'Ваши данные',
            label: 'Получатель',
            inputs: [
                {
                    type: 'text',
                    name: 'firstname',
                    placeholder: 'Имя',
                    required: true,
                    id: 'firstname',
                    model: firstnameValue
                },
                {
                    type: 'text',
                    name: 'lastname',
                    placeholder: 'Фамилия',
                    required: true,
                    id: 'lastname',
                    model: lastnameValue
                },
                {
                    type: 'text',
                    name: 'email',
                    placeholder: 'Email',
                    required: true,
                    id: 'email',
                    model: emailValue
                },
                {
                    type: 'password',
                    name: 'password',
                    placeholder: 'Пароль (мин. 8 символов)',
                    required: true,
                    id: 'password',
                    model: passwordValue
                },
                {
                    type: 'text',
                    name: 'phone',
                    placeholder: 'Номер телефона (начните с «+»)',
                    id: 'phone',
                    model: phoneValue
                }
            ],
            button: {
                text: 'Далее',
                method: sendConfirmCode
            }
        },
        {
            header: 'Подтвердите email',
            label: 'Подтверждение',
            inputs: [
                {
                    type: 'number',
                    name: 'code',
                    id: 'code',
                    placeholder: 'Шестизначный код',
                    model: codeValue,
                    required: true,
                }
            ],
            button: {
                text: 'Зарегистрироваться',
                method: registerUser
            }
        },
        {
            header: 'Добавление адреса',
            label: 'Адрес',
            inputs: [
                {
                    type: 'text',
                    name: 'delivery-service',
                    placeholder: 'Способ доставки: Яндекс ПВЗ',
                    isDisabled: true,
                    required: true,
                    id: 'delivery-service',
                    model: deliveryServiceValue
                },
                {
                    type: 'number',
                    name: 'zip-code',
                    placeholder: 'Индекс',
                    required: true,
                    id: 'zip-code',
                    model: zipCodeValue
                },
                {
                    type: 'text',
                    name: 'country',
                    placeholder: 'Страна',
                    required: true,
                    id: 'country',
                    model: countryValue
                },
                {
                    type: 'text',
                    name: 'region',
                    placeholder: 'Регион',
                    required: true,
                    id: 'region',
                    model: regionValue
                },
                {
                    type: 'text',
                    name: 'city',
                    placeholder: 'Город',
                    required: true,
                    id: 'city',
                    model: cityValue
                },
                {
                    type: 'text',
                    name: 'street',
                    placeholder: 'Улица',
                    required: true,
                    id: 'street',
                    model: streetValue
                },
                {
                    type: 'number',
                    name: 'house',
                    placeholder: 'Дом',
                    required: true,
                    id: 'house',
                    model: houseNumberValue
                },
                // {
                //     type: 'number',
                //     name: 'apartment',
                //     placeholder: 'Квартира',
                //     required: true,
                //     id: 'apartment',
                //     model: apartmentValue
                // },
            ],
            button: {
                text: 'Добавить',
                method: addAddress
            }
        }
        ]
    );

    onMounted(async () => {
        checkPageHeight();
    })
</script>

<template>
    <div :class="[isMobile ? 'row' : '', 'order-container no-account']">
        <div :class="isMobile ? 'col-lg-8 col-md-8 col-12' : 'col-12'">
            <div class="order-elems">
                <h4>До оплаты — три шага</h4>
                <progress-bar :stage="registerStage" :stages="stages"></progress-bar>
                <div class="inputs-block" v-if="registerStage">
                    <div class="input-elem" v-if="stages[registerStage-1].header !== 'Добавление адреса'" v-for="item of stages[registerStage-1].inputs">
                        <input :class="errorType === `no-${item.name}` ? 'error' : ''" v-model="item.model" :type="item.type" :id="item.id" :name="item.name" :placeholder="item.placeholder" :disabled="item.isDisabled">
                        <p class="error-text" v-if="errorType === `no-${item.name}`">Ошибка: {{ errorText }}</p>
                    </div>

                    <div v-if="stages[registerStage-1].header === 'Добавление адреса'">
                        <div v-if="deliveryServiceValue === 'Яндекс ПВЗ'">
                            <ya-delivery-widget @select="updateYaAddress"></ya-delivery-widget>
                        </div>
                    </div>

                    <p class="error-text" v-if="errorType === 'valid-error'">Ошибка: {{ errorText }}</p>

                    <div class="next-step-btn" @click="stages[registerStage-1].button.method"><span>{{ stages[registerStage-1].button.text }}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;

    input.error {
        border: 1px solid $purple
    }

    .col-lg-8:last-child {
        margin-top: 20px;
    }

    .order-elems, .payment-methods {
        background: $white;
        border-radius: 10px;
        padding: 20px;

        display: flex;
        flex-direction: column;
        gap: 10px;

        transition: $transition;
    }

    .no-account h3 {
        margin-bottom: 0;
    }

    .no-account p {
        color: $hard-gray;
        font-size: 14px;
    }

    .no-account p a {
        color: $purple;
        text-decoration: underline;
    }

    .no-account .inputs-block {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .no-account .inputs-block input {
        cursor: text;
    }

    .next-step-btn {
        flex-grow: 0;
        border: 1px solid $silver;
        box-shadow: $shadow;
        border-radius: 10px;
        padding: 10px 15px;
        box-sizing: border-box;
        display: inline-flex;
        flex-direction: row;
        justify-content: center;
        transition: $transition;
        cursor: pointer;
        width: max-content;
        margin-top: 5px;
    }

    .next-step-btn:hover {
        //background: $black-hover;
        box-shadow: $hover-shadow;
    }

    .next-step-btn:hover span {
        //color: $white
    }

    .next-step-btn span {
        color: $black;
        font-size: 14px;
        font-weight: 400;
        transition: $transition;
    }

    .next-step-btn.disabled {
        background: $gray;
        opacity: 0.8;
        cursor: not-allowed;
        transition: $transition;
    }

    .next-step-btn.disabled:hover {
        opacity: 1;
    }

    .error-text {
        font-size: 10px !important;
        padding: 4px 2px 2px;
        color: $purple !important;
    }

    h4 {
        font-weight: 500;
        font-size: 1.2rem;
    }

</style>